// src/web/client/src/pages/Activity.jsx
//
// Activity — what actually happened, in one log (UX brief, Phase B2): the emails
// this app sent (with their opens/clicks) and, on the Platform plan, every step
// the brain took, merged by time and grouped by day.

import React from 'react';
import PageHeader from '@/components/PageHeader';
import ActivityLog from '@/components/activity/ActivityLog';

export default function Activity() {
  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        <PageHeader title="Activity" subtitle="Every email sent and every step taken, as it happened" />
        <ActivityLog />
      </div>
    </div>
  );
}
